import React, { useEffect, useState } from 'react'
import { Button, Typography, Divider,Flex } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import {LeftOutlined ,WechatOutlined,PhoneOutlined,VideoCameraOutlined } from '@ant-design/icons'
import { ImRadioChecked } from 'react-icons/im'
import { TbFileTypePdf } from 'react-icons/tb'
import { database } from '../../utils/firebase'

const { Title, Text, Link } = Typography;

const Results = () => {
  const [result, setResult] = useState(null);

  const{chatID } = useParams();


  const fetchLabDetails= (chatID)=>{
    database.ref(`labTracking/${chatID}`).once("value",(snapshot)=>{
      const response = snapshot.val()
      console.log("response", response)
      setResult(response)

    })
  }
  useEffect(()=>{
    fetchLabDetails(chatID)

  },[])

  return (
    <div>
      <Flex align="center" style={{backgroundColor:"#FFF3F2", padding:"10px 12px",borderBottom:"3px solid #DF7467"}}>
        <Button type="text" size="small" icon={<LeftOutlined />} />
        <Title style={{padding:0, margin:0}} level={5}>Lab Results</Title>
      </Flex>
      <Flex gap="small" style={{padding:"8px"}}>
        <Text strong>
          Patient Name -
        </Text>
        <Text>
          Diagnosis
        </Text>
      </Flex>


    </div>
  )
};

export default Results;
